import { css } from 'styled-components';
import { NewLegalTextProps } from './models';

export const NewLegalText = css<NewLegalTextProps>`
  line-height: 18px;
  font-size: ${({ theme }) => theme.font.size.small};
  color: ${({ theme }) => theme.colors.mediumGray};
`;
